import axios from "axios";
import { auth } from '../../firebase/firebaseConfig';

const authToken = () => auth.currentUser.getIdToken(true);

export default {
    getJobData: async () => {
        return await authToken().then(token => {
            const config = {
                headers: { Authorization: `Bearer ${token}`}
            };

            return axios.get('/api/jobs/', config);
        });
    },

    getSkills: async () => {
        return await authToken().then(token => {
            const config = {
                headers: { Authorization: `Bearer ${token}`}
            };

            return axios.get('/api/jobs/skills', config);
        });
    },

    updateJobSettings: async (data) => {
        return await authToken().then(token => {
            const config = {
                headers: { Authorization: `Bearer ${token}`}
            };

            return axios.put(`/api/jobs/`, data, config);
        });
    },

    updateUserSkills: async (data) => {
        return await authToken().then(token => {
            const config = {
                headers: { Authorization: `Bearer ${token}`}
            };

            return axios.put(`/api/jobs/skills`, data, config);
        });
    },

    updateJobPosting: async (data) => {
        return await authToken().then(token => {
            const config = {
                headers: { Authorization: `Bearer ${token}`}
            };

            return axios.put(`/api/jobs/update`, data, config);
        });
    },
};